module.exports = __webpack_public_path__ + "img/address-1.ab62414f.png";